module.exports = __webpack_public_path__ + "308985f5c759ed3dd5361b8c1d2c0046.fbx";